// Shared by upload ingestion, brief validation, and the onboarding UI.
export const BRIEF_LIMITS = {
    attachments: 500,
    ownerNote: 8000,
    descriptionMinimum: 20,
};
